import {
    Wrapper,
    WrapperFirstRow,
    Line,
    FirstRowBox,
    SecondRowBox,
    ThirdRowBox,
    FourthRowBox,
    RowFlex1,
    RowFlex2,
    FourthRowBoxItem
} from './style'
import React  from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox'
import FooterLogo from '../../image/Sequoia-logo_gold.png'
import Nav from 'react-bootstrap/Nav';

export const Footer = () => {
    const { t } = useTranslation('common');
    return (
        <Wrapper>
            <WrapperFirstRow>
                <RowFlex1>
                    <FirstRowBox>
                        <img 
                            width='154px'
                            height='auto'
                            src={FooterLogo} 
                            alt="footer logo" 
                        />
                    </FirstRowBox>
                    <SecondRowBox>
                        {t('footer.address')}
                    </SecondRowBox>
                </RowFlex1>
                <RowFlex2>
                    <ThirdRowBox>
                        <div>{t('footer.phone')}</div>
                        <Box marginTop="20px">{t('footer.email')}</Box>
                    </ThirdRowBox>
                    <FourthRowBox>
                        <Nav.Link href="/practice-area">
                            <FourthRowBoxItem>{t('footer.practiceArea').toUpperCase()}</FourthRowBoxItem>
                        </Nav.Link>
                        
                        <Nav.Link href="/our-team">
                            <FourthRowBoxItem>{t('footer.meetExperts').toUpperCase()}</FourthRowBoxItem>
                        </Nav.Link>
                        <Nav.Link href="/article-news">
                            <FourthRowBoxItem>{t('footer.articleNews').toUpperCase()}</FourthRowBoxItem>
                        </Nav.Link>
                    </FourthRowBox>
                </RowFlex2>
            </WrapperFirstRow>
            <div>
                <Line />
            </div>
            <Flex alignItems="center" justifyContent="center" textAlign="center">
                &copy; {t('footer.copyright')}
            </Flex>
        </Wrapper>
    )
}